import styled, { createGlobalStyle } from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const GlobalStylesTransformStartNow = createGlobalStyle`
  .contZIndex{
    z-index: 2;
  }
`

export const ContTransformationStartsNowBack = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 0;
`
export const ContTransformationStartsNow = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 0;
  padding-top: 90px !important;
  padding-bottom: 90px !important;
  overflow: hidden;

  @media(min-width: 300px) and (max-width: 767px){
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    padding-top: 70px !important;
    padding-bottom: 70px !important;
  }
`
export const TitleTransform = styled.h3`
  width: 100%;
  margin-bottom: 35px;
  font-family: ${GlobalFonts.fontBold};
  text-align: center;
  color: ${GlobalColors.colorPrimaryDark};
  z-index: 1;
  
  @media(min-width: 300px) and (max-width: 767px){
    margin-bottom: 35px;
    font-size: 30px;
    line-height: 38px;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    margin-bottom: 35px;
    font-size: 40px;
    line-height: 50px;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 36px;
    line-height: 36px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 34px;
    line-height: 46px;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 46px;
    line-height: 56px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    margin-bottom: 70px;
    font-size: 46px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    margin-bottom: 70px;
    font-size: 46px;
  }
  @media(min-width: 1920px){
    margin-bottom: 70px;
    font-size: 46px;
  }
`
export const ContPhone = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media(min-width: 300px) and (max-width: 767px){
    & > img {
      width: 100%;
    } 
  }
  @media(min-width: 768px) and (max-width: 1023px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    & > img {
      width: 70%;
    }
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    & > img {
      width: 70%;
    }
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    & > img {
      width: 70%;
    }
  }
  @media(min-width: 1920px){
    & > img {
      width: 70%;
    }
  }
`
